import * as types from "./types";

export const setHotspotData = (propertyId, values) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_HOTSPOT_DATA,
      payload: { propertyId, values },
    });
  };
};
